// LazySection.jsx
import React from 'react';
import { useInView } from 'react-intersection-observer';

const LazySection = ({ children }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2, // When 20% visible
    });

    return (
        <div ref={ref} style={{ minHeight: '100px' }}>
            {inView ? children : null}
        </div>
    );
};

export default LazySection;
